(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Money formatting
  // /products/{handle}.json returns prices as decimal strings like "75.99",
  // NOT as integers in cents — use parseFloat() directly, never divide by 100.
  // ---------------------------------------------------------------------------
  function formatMoney(amount) {
    var value = parseFloat(amount);
    if (isNaN(value)) return '';
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'de';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  // ---------------------------------------------------------------------------
  // HTML helpers
  // ---------------------------------------------------------------------------
  function escHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPriceEl(price, compareAt, available) {
    var pr = formatMoney(price);
    var cmp = compareAt && parseFloat(compareAt) > parseFloat(price) ? formatMoney(compareAt) : null;
    var soldClass = available ? '' : ' price--sold-out';
    if (cmp) {
      return (
        '<div class="price product-related-compact__price-el price--on-sale' + soldClass + '">' +
          '<div class="price__container"><div class="price__sale">' +
            '<span class="visually-hidden">Regular price</span>' +
            '<span><s class="price-item price-item--regular">' + cmp + '</s></span>' +
            '<span class="visually-hidden">Sale price</span>' +
            '<span class="price-item price-item--sale price-item--last">' + pr + '</span>' +
          '</div></div></div>'
      );
    }
    return (
      '<div class="price product-related-compact__price-el' + soldClass + '">' +
        '<div class="price__container"><div class="price__regular">' +
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="price-item price-item--regular">' + pr + '</span>' +
        '</div></div></div>'
    );
  }

  function variantAvailable(v) {
    // Shopify's AJAX product JSON may omit `available` at the variant level.
    // Treat undefined/null as available so we don't incorrectly disable options.
    return v.available !== false;
  }

  function buildVariantsJson(variants) {
    var vd = variants.map(function (v) {
      return {
        id: v.id,
        available: variantAvailable(v),
        draft: false,
        price_html: formatMoney(v.price),
        compare_at_html:
          v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
            ? formatMoney(v.compare_at_price)
            : null,
      };
    });
    return JSON.stringify({ variants: vd });
  }

  function buildCardHtml(product, primaryVariant, rec, idPrefix, index, opts) {
    var productUrl = '/products/' + escHtml(product.handle);
    var variantUrl = primaryVariant ? productUrl + '?variant=' + primaryVariant.id : productUrl;

    // For variant-type recs, limit the select to same-color variants and show
    // only the non-color option values (e.g. just "S" instead of "Red / S").
    // Match directly against option1/2/3 values — do NOT rely on product.options
    // which may be absent or formatted differently across API versions.
    // For product-type recs, show all variants with full titles.
    var displayVariants = product.variants;
    var getOptionTitle = function (v) { return v.title; };

    if (rec && rec.type === 'variant' && rec.group_label) {
      var groupLabel = String(rec.group_label).toLowerCase().trim();
      var filtered = product.variants.filter(function (v) {
        return (
          String(v.option1 || '').toLowerCase().trim() === groupLabel ||
          String(v.option2 || '').toLowerCase().trim() === groupLabel ||
          String(v.option3 || '').toLowerCase().trim() === groupLabel
        );
      });
      if (filtered.length > 0) {
        displayVariants = filtered;
        // Title: all option values except the one matching the color label
        getOptionTitle = function (v) {
          var parts = ['option1', 'option2', 'option3']
            .map(function (k) { return v[k] || ''; })
            .filter(function (val) {
              return val && String(val).toLowerCase().trim() !== groupLabel;
            });
          return parts.length > 0 ? parts.join(' / ') : v.title;
        };
      }
    }

    var variantIds = displayVariants.map(function (v) { return v.id; }).join('||');
    var variantTitles = displayVariants.map(function (v) { return escHtml(v.title); }).join('||');
    var hasOptions = !product.has_only_default_variant && displayVariants.length > 1;
    var isAvailable = primaryVariant ? variantAvailable(primaryVariant) : false;

    var imgSrc = rec && rec.image_url ? rec.image_url : null;
    if (!imgSrc && primaryVariant && primaryVariant.featured_image) {
      imgSrc = primaryVariant.featured_image.src || primaryVariant.featured_image.url || null;
    }
    if (!imgSrc && product.featured_image) {
      imgSrc =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || product.featured_image.url || null;
    }

    /* Breite/Hoehe mitgeben, wo die Produkt-JSON sie kennt: ohne feste
       Box (siehe CSS) bestimmt das Bild selbst seine Hoehe, und nur die
       Masse im Markup reservieren den Platz schon vor dem Laden. */
    var imgSize = null;
    if (primaryVariant && primaryVariant.featured_image && primaryVariant.featured_image.width) {
      imgSize = primaryVariant.featured_image;
    } else if (product.featured_image && product.featured_image.width) {
      imgSize = product.featured_image;
    }
    var imgDims = imgSize
      ? ' width="' + imgSize.width + '" height="' + imgSize.height + '"'
      : '';

    var imgHtml = imgSrc
      ? '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(product.title) +
          '" class="product-related-compact__img motion-reduce" loading="lazy"' + imgDims + '>'
      : '';

    var priceHtml = primaryVariant
      ? buildPriceEl(primaryVariant.price, primaryVariant.compare_at_price, primaryVariant.available)
      : '';

    var selectHtml;
    if (hasOptions) {
      var options = displayVariants
        .map(function (v) {
          var sel = primaryVariant && v.id === primaryVariant.id ? ' selected' : '';
          var avail = variantAvailable(v);
          var dis = avail ? '' : ' disabled';
          return (
            '<option value="' + v.id + '"' + sel + dis +
            ' data-available="' + avail + '" data-draft="false">' +
            escHtml(getOptionTitle(v)) + '</option>'
          );
        })
        .join('');
      selectHtml =
        '<div class="product-related-compact__select-wrap">' +
          '<select class="product-related-compact__variant-select"' +
          ' id="RelatedVariant-' + escHtml(idPrefix) + '-' + index + '"' +
          ' aria-label="' + escHtml(opts.chooseOptions) + '"' +
          ' data-related-compact-select>' +
          options +
          '</select>' +
          '<span class="product-related-compact__select-icon" aria-hidden="true">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">' +
              '<path d="M9.354.646a.5.5 0 00-.707 0L5 4.293 1.354.646a.5.5 0 00-.707.707l4 4a.5.5 0 00.707 0l4-4a.5.5 0 000-.707z"/>' +
            '</svg>' +
          '</span>' +
        '</div>';
    } else {
      selectHtml = '<div class="product-related-compact__select-spacer" aria-hidden="true">Einheitsgröße</div>';
    }

    var formId = 'VcmRelatedCompact-' + escHtml(idPrefix) + '-' + index;
    var submitLabel = isAvailable ? escHtml(opts.buttonLabel) : escHtml(opts.soldOut);
    var ariaLabel = isAvailable ? escHtml(opts.addToCart) : escHtml(opts.soldOut);

    return (
      '<li class="grid__item product-related-compact__item"' +
        ' data-vcm-product-handle="' + escHtml(product.handle) + '"' +
        ' data-vcm-product-title="' + escHtml(product.title) + '"' +
        ' data-vcm-variant-ids="' + variantIds + '"' +
        ' data-vcm-variant-titles="' + variantTitles + '"' +
        ' data-product-base-url="' + productUrl + '"' +
        ' data-i18n-regular="' + escHtml(opts.regularPrice) + '"' +
        ' data-i18n-sale="' + escHtml(opts.salePrice) + '">' +
        '<div class="product-related-compact__card">' +
          '<a href="' + variantUrl + '" class="product-related-compact__media" tabindex="-1">' +
            imgHtml +
          '</a>' +
          '<div class="product-related-compact__body">' +
            '<a href="' + variantUrl + '" class="product-related-compact__title">' +
              escHtml(product.title) +
            '</a>' +
            '<div class="product-related-compact__price" data-related-compact-price>' +
              priceHtml +
            '</div>' +
            '<div class="product-related-compact__grow" aria-hidden="true"></div>' +
            '<script type="application/json" data-related-compact-variants>' +
              buildVariantsJson(displayVariants) +
            '<\/script>' +
            '<div class="product-related-compact__actions">' +
            selectHtml +
            '<product-form class="product-related-compact__product-form" data-hide-errors="true" data-silent-add="true">' +
              '<form id="' + formId + '" action="/cart/add" method="post"' +
                ' class="product-related-compact__form" novalidate>' +
                '<input type="hidden" name="form_type" value="product">' +
                '<input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="id"' +
                  ' value="' + (primaryVariant ? primaryVariant.id : '') + '"' +
                  ' data-related-compact-variant-id>' +
                '<button type="submit" name="add"' +
                  ' class="product-related-compact__submit"' +
                  ' data-related-compact-submit' +
                  ' data-add-label="' + escHtml(opts.buttonLabel) + '"' +
                  ' data-aria-add="' + escHtml(opts.addToCart) + '"' +
                  ' data-aria-sold="' + escHtml(opts.soldOut) + '"' +
                  ' data-sold-out-label="' + escHtml(opts.soldOut) + '"' +
                  ' aria-label="' + ariaLabel + '"' +
                  (isAvailable ? '' : ' disabled') + '>' +
                  '<span class="product-related-compact__submit-icon" aria-hidden="true">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40">' +
                      '<path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"/>' +
                    '</svg>' +
                  '</span>' +
                  '<span class="product-related-compact__submit-text" data-related-compact-submit-label>' +
                    submitLabel +
                  '</span>' +
                  '<div class="loading__spinner hidden">' +
                    '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                    '</svg>' +
                  '</div>' +
                '</button>' +
              '</form>' +
            '</product-form>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function buildGridHtml(heading, cardHtmlArray) {
    return (
      '<div class="product-related-compact__inner">' +
        (heading ? '<h3 class="product-related-compact__heading">' + escHtml(heading) + '</h3>' : '') +
        '<ul class="grid product-related-compact__grid grid--3-col-desktop grid--2-col-tablet-down" role="list">' +
          cardHtmlArray.join('') +
        '</ul>' +
      '</div>'
    );
  }

  // ---------------------------------------------------------------------------
  // Case-insensitive lookup in variantRecs object
  // ---------------------------------------------------------------------------
  function findVariantRecs(variantRecs, color) {
    if (!color || !variantRecs) return null;
    var colorLower = color.toLowerCase().trim();
    var keys = Object.keys(variantRecs);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase().trim() === colorLower) {
        var recs = variantRecs[keys[i]];
        if (Array.isArray(recs) && recs.length > 0) return recs;
      }
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // Custom element
  // ---------------------------------------------------------------------------
  class VcmCompactRecommendations extends HTMLElement {
    constructor() {
      super();
      this._onColorChange = this._onColorChange.bind(this);
      this._productCache = {};
      this._shopifyHtml = null;
      this._lastSourceKey = null;
      this._updating = false;
      this._pendingUpdate = false;
    }

    connectedCallback() {
      window.addEventListener('vcm:colorChange', this._onColorChange);

      const io = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          // Defer by one macrotask so VariantSelects.connectedCallback's
          // setTimeout(0) fires first and broadcasts the initial color via
          // vcm:colorChange before we read window.VCM.currentColorValue.
          setTimeout(() => this._scheduleUpdate(), 0);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      io.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('vcm:colorChange', this._onColorChange);
    }

    _onColorChange() {
      this._scheduleUpdate();
    }

    _scheduleUpdate() {
      if (this._updating) {
        this._pendingUpdate = true;
        return;
      }
      this._doUpdate();
    }

    async _doUpdate() {
      const color = window.VCM.getCurrentColor();
      const data = this._readData();
      const variantRecs = data.variantRecs || {};
      const productRecs = Array.isArray(data.productRecs) ? data.productRecs : [];

      const colorRecs = findVariantRecs(variantRecs, color);
      let sourceKey;
      let recs;

      if (colorRecs) {
        sourceKey = 'variant:' + color;
        recs = colorRecs;
      } else if (productRecs.length > 0) {
        sourceKey = 'product';
        recs = productRecs;
      } else {
        sourceKey = 'shopify';
        recs = null;
      }

      if (sourceKey === this._lastSourceKey) return;

      // Show loading spinner before any network fetch
      const needsFetch =
        (sourceKey === 'shopify' && !this._shopifyHtml) ||
        (sourceKey !== 'shopify' &&
          recs &&
          recs.some((r) => !this._productCache[r.product_handle]));
      if (needsFetch) this._showLoading();

      this._updating = true;
      try {
        let success;
        if (sourceKey === 'shopify') {
          success = await this._loadShopifyDefault();
        } else {
          success = await this._renderVcmRecs(recs);
          if (!success) {
            // All products failed to load — fall back to Shopify default
            sourceKey = 'shopify';
            success = await this._loadShopifyDefault();
          }
        }
        // Only record the source after a successful render so the next
        // update retries if something went wrong.
        if (success) this._lastSourceKey = sourceKey;
      } catch (e) {
        // Leave existing content and let the next update retry
      } finally {
        this._updating = false;
        if (this._pendingUpdate) {
          this._pendingUpdate = false;
          this._scheduleUpdate();
        }
      }
    }

    _readData() {
      const script = this.querySelector('script[data-vcm-compact-recs]');
      if (!script) return { variantRecs: {}, productRecs: [] };
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return { variantRecs: {}, productRecs: [] };
      }
    }

    _showLoading() {
      Array.from(this.children).forEach((child) => {
        if (child.tagName === 'SCRIPT' && child.hasAttribute('data-vcm-compact-recs')) return;
        if (child.tagName === 'LINK' || child.tagName === 'STYLE') return;
        child.remove();
      });
      const el = document.createElement('div');
      el.className = 'vcm-compact-loading';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML =
        '<div class="loading__spinner">' +
          '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
            '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
          '</svg>' +
        '</div>';
      this.appendChild(el);
    }

    async _fetchProduct(handle) {
      if (this._productCache[handle]) return this._productCache[handle];
      try {
        const resp = await fetch('/products/' + encodeURIComponent(handle) + '.json');
        if (!resp.ok) return null;
        const json = await resp.json();
        const product = json.product || null;
        if (product) this._productCache[handle] = product;
        return product;
      } catch (e) {
        return null;
      }
    }

    // Returns true if at least one card was rendered, false otherwise.
    async _renderVcmRecs(recs) {
      const limit = parseInt(this.dataset.productsLimit || '3', 10);
      const heading = this.dataset.heading || '';
      const buttonLabel = this.dataset.buttonLabel || 'Hinzufügen';
      const idPrefix = this.dataset.idPrefix || 'vcm';

      const opts = {
        buttonLabel,
        chooseOptions: this.dataset.i18nChooseOptions || 'Choose options',
        addToCart: this.dataset.i18nAddToCart || 'Add to cart',
        soldOut: this.dataset.i18nSoldOut || 'Sold out',
        regularPrice: this.dataset.i18nRegularPrice || 'Regular price',
        salePrice: this.dataset.i18nSalePrice || 'Sale price',
      };

      const toRender = recs.slice(0, limit);

      const products = await Promise.all(
        toRender.map((rec) => this._fetchProduct(rec.product_handle))
      );

      const cards = [];
      for (let i = 0; i < toRender.length; i++) {
        const product = products[i];
        if (!product) continue;
        // Shared with the Liquid side — see vcm-utils.js / vcm-primary-variant.liquid
        const primaryVariant = window.VCM.findPrimaryVariant(product, toRender[i]);
        cards.push(buildCardHtml(product, primaryVariant, toRender[i], idPrefix, i, opts));
      }

      if (cards.length === 0) return false;

      this._replaceContent(buildGridHtml(heading, cards));
      return true;
    }

    // Returns true if content was rendered.
    async _loadShopifyDefault() {
      // Serve from cache to avoid a network round-trip on repeated visits
      if (this._shopifyHtml) {
        this._replaceContent(this._shopifyHtml);
        return true;
      }

      const url = this.dataset.shopifySectionUrl;
      if (!url) return false;

      const resp = await fetch(url);
      if (!resp.ok) return false;
      const text = await resp.text();

      const doc = document.createElement('div');
      doc.innerHTML = text;

      const key = this.dataset.recommendationKey;
      let sourceEl = null;
      if (key) {
        try {
          sourceEl = doc.querySelector('[data-recommendation-key="' + CSS.escape(key) + '"]');
        } catch (e) {
          sourceEl = doc.querySelector('[data-recommendation-key="' + key + '"]');
        }
      }
      if (!sourceEl) {
        sourceEl = doc.querySelector('vcm-compact-recommendations, product-recommendations');
      }

      const inner = sourceEl && sourceEl.querySelector('.product-related-compact__inner');
      if (!inner) return false;

      this._shopifyHtml = inner.outerHTML;
      this._replaceContent(this._shopifyHtml);
      return true;
    }

    _replaceContent(html) {
      Array.from(this.children).forEach((child) => {
        if (child.tagName === 'SCRIPT' && child.hasAttribute('data-vcm-compact-recs')) return;
        if (child.tagName === 'LINK' || child.tagName === 'STYLE') return;
        child.remove();
      });
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      while (tmp.firstChild) {
        this.appendChild(tmp.firstChild);
      }
    }
  }

  customElements.define('vcm-compact-recommendations', VcmCompactRecommendations);
})();
